import { Component } from '@angular/core';
import { NavParams, NavController } from 'ionic-angular';
import { Usuario } from '../../entities/usuario';
import { HomePage } from '../../pages/home/home';
import { LoginPage } from '../../pages/login/login';
import { MenuHelper } from '../../utils/menu-helper';
import { Notifications } from '../../providers/notifications/notifications';

@Component({
    selector: 'menu',
    templateUrl: './menu.html'
})
export class MenuComponent {
    public usuario: Usuario;

    public menuPerfil: any[];

    public rootPage = HomePage;

    constructor(_navParams: NavParams, private _notifications: Notifications, private _navCtrl: NavController) {
        this.usuario = _navParams.get('usuario');
        _notifications.prepare(this.usuario);
        this.menuPerfil = MenuHelper.getMenuToPrifile(this.usuario.Perfil);
    }

    public logout(): void {
        this._notifications.destroy(this.usuario);
        this._navCtrl.setRoot(LoginPage);
    }
}


// WEBPACK FOOTER //
// ./src/components/menu/menu.ts